// D-2 SC3: the clinic letterhead for a report (greenlight R-0185). The clinic's fields REPLACE the specialist's own
// letterhead fields (all of them, even a blank one); the signature and the signer's name stay the specialist's.
// Resolution lives in the database (report_branding_for_client): NULL = no clinic letterhead -> the personal one.

export const CLINIC_LOGO_BUCKET = 'clinic-library';
// clinic_branding column -> the report_settings key the renderers already read
const MAP = {
  practice_name: 'practice_name', practice_address: 'practice_address', practice_phone: 'practice_phone',
  practice_email: 'practice_email', header_color: 'header_color', font_style: 'font_style', header_style: 'header_style',
  footer_text: 'footer_text', brand_primary: 'brand_primary', brand_accent: 'brand_accent',
};

// Pure. personal = the merged report_settings (defaults applied); row = the RPC result or null.
export function mergeClinicBranding(personal, row, defaults) {
  if (!row || typeof row !== 'object' || !row.clinic_id) return personal;
  const out = { ...personal };
  for (const [from, to] of Object.entries(MAP)) {
    const v = row[from];
    out[to] = (v === null || v === undefined || v === '') ? ((defaults && defaults[to] !== undefined) ? defaults[to] : null) : v;
  }
  out.logo_storage_path = row.logo_path || null;          // never the personal logo under a clinic letterhead
  out.logo_bucket = row.logo_path ? CLINIC_LOGO_BUCKET : null;
  out.clinic_id = row.clinic_id;
  out.clinic_branding_rev = row.rev == null ? null : row.rev;
  return out;                                              // signature_path, signer fields: untouched (the member's own)
}

export function refKey(ref) {
  const sp = ref && ref.specialistPatientId ? String(ref.specialistPatientId) : '';
  const ch = ref && ref.childId ? String(ref.childId) : '';
  return (sp || ch) ? sp + '|' + ch : '';
}

const TTL_MS = 60000;
const _memo = new Map();   // key -> { at, row }  (a failed read is never cached)
export function _resetClinicBrandingMemo() { _memo.clear(); }

// The RPC read. Returns the row or null. An error is logged and returns null (the personal letterhead) and is not cached.
export async function resolveClinicBranding(supa, ref, now) {
  const key = refKey(ref);
  if (!key || !supa || !supa.rpc) return null;
  const t = now == null ? Date.now() : now;
  const hit = _memo.get(key);
  if (hit && t - hit.at < TTL_MS) return hit.row;
  try {
    const { data, error } = await supa.rpc('report_branding_for_client', {
      p_specialist_patient_id: ref.specialistPatientId || null, p_child_id: ref.childId || null });
    if (error) { console.error('❌ report_branding_for_client:', error); return null; }
    const row = data && typeof data === 'object' && data.clinic_id ? data : null;
    _memo.set(key, { at: t, row });
    return row;
  } catch (e) { console.error('❌ report_branding_for_client:', e); return null; }
}

// personal -> personal or the merged clinic letterhead for this client.
export async function brandingForClientRef(supa, personal, ref, defaults) {
  const row = await resolveClinicBranding(supa, ref);
  return mergeClinicBranding(personal, row, defaults);
}

// The client a report is about: explicit ref wins, else the report row's own ids.
export function clientRefOf(ctx) {
  const c = ctx && ctx.clientRef;
  if (c && refKey(c)) return c;
  const r = ctx && ctx.report;
  if (r && (r.specialist_patient_id || r.child_id)) return { specialistPatientId: r.specialist_patient_id || null, childId: r.child_id || null };
  return null;
}
